import { atom } from 'jotai';
import { isCookieFirstLoaded } from './utils';

export const cookieFirstLoadedAtom = atom(isCookieFirstLoaded());
